// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"b2954034","354":"88912cad","455":"19b3c47c","495":"1d7698a8","609":"1c10d4a4","627":"56e81ece","943":"f6fe8499"}[chunkId] + ".chunk.js";
};